<template>
    <b-modal
             id="xero-integration-steps"
             ref="xero-integration-steps"
             :size="thirdStep ? 'invite-member' : 'lg-size'"
             modal-class="modal-xero"
             no-close-on-esc
             no-close-on-backdrop
             centered
             hide-footer
             hide-header
             @hide="close"
    >
        <div class="modal-head">
            <div class="title-wrap" v-if="firstStep">
                <h2 class="modal-title">
                    {{ 'Pay Items'}}
                </h2>
            </div>
            <div class="title-wrap" v-if="secondStep">
                <h2 class="modal-title">
                    {{'Import Team'}}
                </h2>
            </div>
            <h2 class="modal-title" v-if="thirdStep">
                {{label.get('subscription_purchase_additional_seats')}}
            </h2>
            <h4 v-if="finalStep">{{ 'Account Integrated Successfully' }}</h4>
            <div class="quickbooks-logo">
                <img
                        src="/assets/images/xero-logo-blue.svg"
                        alt="Atto"
                        class="black-logo"
                        width="50"
                        height="50"
                >
            </div>
        </div>
        <div v-if="firstStep || secondStep || finalStep" class="content-wrapper quickbooks-container" :class="{disclaimer: showResumeSubscription}">
            <div v-if="firstStep" class="login-container signup-quickbooks synchronize-container">
                <h4>{{'Map your Xero pay items to the relevant category recorded in Atto. You can only select one pay item per category.'}}</h4>
                <div class="s-team-wrapper body-container">
                    <div class="head-labels">
                        <div class="label email">
                            <p>
                                {{'Category'}}
                            </p>
                        </div>
                        <div class="label">
                            <p>
                                {{'Earnings Name'}}
                            </p>
                        </div>
                    </div>
                    <ul class="quickbooks-member-list">
                        <li>
                            <div class="field-row">
                                <div class="member-name">
                                    <p class="member-name">
                                        {{ 'Regular Hours' }}
                                    </p>
                                </div>
                                <div class="member-name">
                                    <select-dropdown-component
                                            v-model="regular_selected_id"
                                            placeholder="Select Regular:"
                                            :options="regularHours"
                                            @onOptionSelected="onRegularSelected"
                                    />
                                </div>
                            </div>
                        </li>
                        <li>
                            <div class="field-row">
                                <div class="member-name">
                                    <p class="member-name">
                                        {{ 'Overtime Hours' }}
                                    </p>
                                </div>
                                <div class="member-name">
                                    <select-dropdown-component
                                            v-model="overtime_selected_id"
                                            placeholder="Select Overtime:"
                                            :options="overtimeHours"
                                            @onOptionSelected="onOvertimeSelected"
                                    />
                                </div>
                            </div>
                        </li>
                    </ul>
                </div>
                <span v-if="payItemsError" class="error-message" style="padding-left: 48px;">
                    {{payItemsError}}
                </span>
            </div>
            <div v-if="secondStep">
                <div
                        v-if="showResumeSubscription"
                        class="subscription-cancelled"
                        :class="{seats: showPurchaseSeats}"
                >
                    <p class="disclaimer">
                        {{label.get('your_subscription_is_set_to_cancel_at_the_end_of_your_current_billing_period')}}
                    </p>
                </div>
                <div
                        v-if="!showResumeSubscription"
                        class="login-container signup-quickbooks synchronize-container"
                >
                    <h4>{{'Import and match employees from your Xero account to Atto.'}}</h4>
                    <div class="s-team-wrapper body-container">
                        <div class="head-labels">
                            <div class="label email">
                                <p>
                                    {{'Xero Employee'}}
                                </p>
                            </div>
                            <div class="label">
                                <p>
                                    {{'Match to Atto'}}
                                </p>
                            </div>
                        </div>
                        <ul class="quickbooks-member-list">
                            <li
                                    v-for="(user, idx) in userWithoutEmail"
                                    :key="idx"
                            >
                                <div class="field-row">
                                    <div class="check-wrapper">
                                        <b-form-checkbox
                                                v-model="user.checked"
                                                :index="idx"
                                        />
                                    </div>
                                    <div class="member-name">
                                        <p class="member-name">
                                            {{ user.name }}
                                        </p>
                                    </div>
                                    <div class="member-dropdown">
                                        <div class="dropdown match">
                                            <div class="role-wrap">
                                                <select-dropdown-component
                                                        v-if="user.showDropdown"
                                                        v-model="user.user_id"
                                                        :index="idx"
                                                        placeholder="Select User:"
                                                        :options="companyUsers"
                                                        @onOptionSelected="onUserSelected"
                                                />
                                                <input
                                                        v-if="!user.showDropdown"
                                                        v-model="user.input_email"
                                                        type="text"
                                                        placeholder="Enter email"
                                                >
                                            </div>
                                            <span class="invite-error-span"/>
                                        </div>
                                        <div class="input-email hidden">
                    <span
                            v-if="user.duplicateDropdownError"
                            class="error-message"
                    >{{label.get('you_have_duplicate_selections')}}</span>
                                            <span
                                                    v-if="user.duplicateEmailError"
                                                    class="error-message"
                                            >{{label.get('you_have_duplicate_emails')}}</span>
                                            <span
                                                    v-if="user.validEmailError"
                                                    class="error-message"
                                            >{{label.get('not_valid_email_address')}}</span>
                                            <span
                                                    v-if="user.selectOneItemError"
                                                    class="error-message"
                                            >{{label.get('please_select_one_user')}}</span>
                                            <span
                                                    v-if="user.inputEmptyError"
                                                    class="error-message"
                                            >{{label.get('please_provide_your_email_address')}}</span>
                                            <span
                                                    v-if="user.backEndError"
                                                    class="error-message"
                                            >{{ user.backEndErrorMessage }}</span>
                                        </div>
                                    </div>
                                </div>
                            </li>
                            <li
                                    v-for="(user, idx) in userToInvite"
                                    :key="`A-${idx}`"
                            >
                                <div class="field-row">
                                    <div class="check-wrapper">
                                        <b-form-checkbox
                                                v-model="user.checked"
                                                :index="idx"
                                        />
                                    </div>
                                    <div class="member-name">
                                        <p class="member-name">
                                            {{ user.name }}
                                        </p>
                                    </div>
                                    <div class="member-dropdown">
                                        <div class="input-email hidden">
                                            <input
                                                    v-model="user.input_email"
                                                    placeholder="Enter email"
                                            >
                                            <span
                                                    v-if="user.duplicateEmailError"
                                                    class="error-message"
                                            >{{label.get('you_have_duplicate_emails')}}</span>
                                            <span
                                                    v-if="user.validEmailError"
                                                    class="error-message"
                                            >{{label.get('not_valid_email_address')}}</span>
                                            <span
                                                    v-if="user.selectOneItemError"
                                                    class="error-message"
                                            >{{label.get('please_select_one_user')}}</span>
                                            <span
                                                    v-if="user.inputEmptyError"
                                                    class="error-message"
                                            >{{label.get('email_is_required')}}</span>
                                            <span
                                                    v-if="user.backEndError"
                                                    class="error-message"
                                            >{{ user.backEndErrorMessage }}</span>
                                        </div>
                                    </div>
                                </div>
                            </li>
                            <li
                                    v-for="(user, idx) in matchUsers"
                                    :key="`B-${idx}`"
                            >
                                <div class="field-row">
                                    <div class="check-wrapper">
                                        <b-form-checkbox
                                                v-model="user.checked"
                                                :index="idx"
                                        />
                                    </div>
                                    <div class="member-name">
                                        <p class="member-name">
                                            {{ user.name }}
                                        </p>
                                    </div>
                                    <div class="member-dropdown">
                                        <div class="dropdown match">
                                            <div class="role-wrap">
                                                <select-dropdown-component
                                                        v-if="user.showDropdown"
                                                        v-model="user.user_id"
                                                        :index="idx"
                                                        placeholder="Select User:"
                                                        :options="companyUsers"
                                                        @onOptionSelected="onUserMatchSelected"
                                                />
                                                <input
                                                        v-if="!user.showDropdown"
                                                        v-model="user.input_email"
                                                        type="text"
                                                        placeholder="Enter email"
                                                >
                                            </div>
                                        </div>
                                        <div class="input-email hidden">
                    <span
                            v-if="user.duplicateDropdownError"
                            class="error-message"
                    >{{label.get('you_have_duplicate_selections')}}</span>
                                            <span
                                                    v-if="user.duplicateEmailError"
                                                    class="error-message"
                                            >{{label.get('you_have_duplicate_emails')}}</span>
                                            <span
                                                    v-if="user.validEmailError"
                                                    class="error-message"
                                            >{{label.get('not_valid_email_address')}}</span>
                                            <span
                                                    v-if="user.selectOneItemError"
                                                    class="error-message"
                                            >{{label.get('please_select_one_user')}}</span>
                                            <span
                                                    v-if="user.inputEmptyError"
                                                    class="error-message"
                                            >{{label.get('email_is_required')}}</span>
                                            <span
                                                    v-if="user.backEndError"
                                                    class="error-message"
                                            >{{ user.backEndErrorMessage }}</span>
                                        </div>
                                    </div>
                                </div>
                            </li>
                        </ul>
                    </div>
                    <p class="disclaimer">
                        {{'Unchecked employees will not be added to your Atto account.'}}
                    </p>
                </div>
            </div>
            <p class="disclaimer" v-if="finalStep">
                {{ 'Your Atto account has been successfully integrated to Xero. If you have any questions, please contact support@attotime.com' }}
            </p>
        </div>
        <div v-if="thirdStep" class="content-wrapper hasScroll">
            <perfect-scrollbar v-if="invites.length > 0">
                <p class="seats-desc">
                    {{label.get('subscription_purchase_additional_seats_description')}}
                </p>
                <div class="head-labels">
                    <div class="label email">
                        <p>
                            {{label.get('email')}}
                        </p>
                    </div>
                    <div class="label">
                        <p>
                            {{label.get('role')}}
                        </p>
                    </div>
                </div>
                <div
                        v-for="(item, idx) in invites"
                        :key="idx"
                        class="field-row"
                >
                    <div class="email-wrap">
                        <input
                                v-model="item.email"
                                type="email"
                                :class="{ error: item.error }"
                                :placeholder="label.get('enter_email_address')"
                                class="atto-input"
                        >
                    </div>
                    <div class="role-wrap">
                        <select-dropdown-component
                                :value="item.role"
                                :index="idx"
                                placeholder="Select Role:"
                                :options="roles"
                                @onOptionSelected="onRoleSelected"
                        />
                    </div>
                    <button
                            v-if="!item.deleting"
                            class="delete-member"
                            @click="deleteInvite(item)"
                    >
                        <i class="atto atto-delete" />
                    </button>
                    <transition
                            v-if="!item.deleting"
                            name="fade"
                    >
                        <div
                                v-if="item.confirm_delete"
                                class="confirm-delete"
                        >
                            <span class="confirm-msg">{{label.get('are_you_sure')}}</span>
                            <button
                                    class="confirm-delete-btn"
                                    @click="confirmDelete(item)"
                            >
                                {{label.get('delete')}}
                            </button>
                            <button
                                    class="cancel-delete"
                                    @click="cancelConfirmDelete(item)"
                            >
                                <i class="atto atto-close-btn" />
                            </button>
                        </div>
                    </transition>
                </div>
            </perfect-scrollbar>
            <div class="additional-seats-form">
                <div class="form-head quickbooks">
                    <span class="no">{{label.get('subscription_number_of_users')}}</span>
                    <span class="price">{{label.get('subscription_price_per_user')}}</span>
                    <span class="total">{{label.get('subscription_total_amount')}}</span>
                </div>
                <div class="form-fields">
                    <span class="price">{{ seats }}</span>
                    <span class="price">${{ proratedCostPerUser }}</span>
                    <span class="total">${{ totalAmount }}</span>
                </div>
                <span
                        v-if="error"
                        class="error-message"
                >{{ errorMessage }}</span>
            </div>
        </div>
        <div class="modal-footer">
            <button
                    v-if="firstStep"
                    class="atto-btn submit"
                    type="submit"
                    @click="submitFirstStep"
            >
                {{label.get('continue')}}
            </button>
            <div v-if="secondStep">
                <button
                        type="reset"
                        class="atto-btn cancel"
                        data-dismiss="modal"
                        @click="cancelInEmployee"
                >
                    {{label.get('cancel')}}
                </button>
                <button
                        v-if="!showResumeSubscription"
                        class="atto-btn submit"
                        type="submit"
                        @click="submitSecondStep"
                >
                    {{label.get('continue')}}
                </button>
                <button
                        v-if="showResumeSubscription"
                        type="submit"
                        class="atto-btn submit"
                        @click="reactivateSubscription"
                >
                    {{label.get('reactivate_subscription')}}
                </button>
            </div>
            <div v-if="thirdStep">
                <div class="form-disclaimer top">
                    <p>
                        {{label.get('subscription_purchase_additional_seats_prorated_amount')}}
                    </p>
                </div>
                <div class="form-buttons">
                    <button
                            type="reset"
                            class="atto-btn cancel"
                            @click="closePurchaseSeatsButton"
                    >
                        {{label.get('cancel')}}
                    </button>
                    <button
                            type="submit"
                            class="atto-btn submit"
                            @click="purchaseSeatsSubmit"
                    >
                        {{label.get('subscription_complete_purchase')}}
                    </button>
                </div>
                <div class="form-disclaimer bottom">
                    <p class="disclaimer">
                        {{label.get('subscription_purchase_additional_seats_description_one')}}
                    </p>
                    <p>
                        {{label.get('subscription_purchase_additional_seats_description_two')}}
                    </p>
                </div>
            </div>
            <button
                    v-if="finalStep"
                    type="button"
                    class="atto-btn submit go-to"
                    @click="close"
            >
                {{ label.get('go_to_account') }}
            </button>
        </div>
    </b-modal>
</template>

<script>
    import CompanyService from "../services/CompanyService";
    import SelectDropdownComponent from "../../../../shared/components/SelectDropdownComponent";
    import InviteService from "../../../../shared/services/InviteService";
    import BillingService from "../../billing/services/BillingService";
    import {required} from 'vuelidate/lib/validators'

    export default {
        name: "XeroIntegrationStepsComponent",
        components: {
            SelectDropdownComponent
        },
        data() {
            return {
                firstStep: true,
                secondStep: false,
                thirdStep: false,
                finalStep: false,
                regularHours: [],
                overtimeHours: [],
                regular_selected: null,
                regular_selected_id: null,
                overtime_selected: null,
                overtime_selected_id: null,
                companyUsers: [],
                matchUsers: [],
                userWithoutEmail: [],
                userToInvite: [],
                showPurchaseSeats: false,
                showNotAccountOwner: false,
                showResumeSubscription: false,
                purchaseSeats: 0,
                proratedCostPerUser: 0,
                isFirstPurchaseStripeTax: false,
                totalAmount: 0,
                discard: false,
                error: false,
                errorMessage: '',
                invalidEmails: false,
                payInvoiceRetryCount: 1,
                invites: [
                    {
                        id: null,
                        email: '',
                        role: 3,
                        error: false,
                        payroll_calendar_id: null,
                        employee_id: null

                    }
                ],
                roles: [
                    {
                        value: 1,
                        label: this.label.get('admin')
                    },
                    {
                        value: 2,
                        label: this.label.get('manager')
                    },
                    {
                        value: 3,
                        label: this.label.get('employee')
                    }
                ],
                seats: 1,
                min: 1,
                max: 999,
                payItemsError: '',
            }
        },

        watch: {
            seats(newVal, oldVal) {
                const val = parseInt(newVal);
                if (!isNaN(val) && !isNaN(oldVal) && (val > 999 || val < 1)) {
                    this.seats = parseInt(oldVal);
                }

                if (val === 0) {
                    this.seats = '';
                }
                this.error = false;
            }
        },
        validations: {
            seats: {
                required
            }
        },
        mounted() {
            const _this = this;
            document.body.appendChild(this.$el);
            this.$store.commit('showLoading');
            CompanyService.getXeroPayItems().then((result) => {
                    if (result.overtime_selected !== null) {
                        _this.overtime_selected_id = result.overtime_selected.value;
                    }
                    if (result.regular_selected !== null) {
                        _this.regular_selected_id = result.regular_selected.value;
                    }

                    _this.overtime_selected = result.overtime_selected;
                    _this.regular_selected = result.regular_selected;
                    _this.regularHours = result.regular;
                    _this.overtimeHours = result.overtime;
                    _this.$refs['xero-integration-steps'].show();
                    _this.$store.commit('hideLoading');
                }
            ).catch(error => {
                this.$store.commit('hideLoading');
                if (error.response.status === 403) {
                    this.$store.commit('xeroHasError403', true);
                    this.$root.$emit('showXeroErrors');
                }
            });
        },
        methods: {
            submitFirstStep() {

                const data = {
                    regular: this.regular_selected,
                    overtime: this.overtime_selected,
                };

                CompanyService.postXeroPayItems(data).then((result) => {
                    this.getXeroEmployee();
                }).catch(error => {
                    debugger;
                    this.payItemsError = error.response.data.error.message;
                });

            },
            getXeroEmployee() {
                this.$store.commit('showLoading');
                CompanyService.getXeroEmployees().then((result) => {
                    if (result.seatsAvailable !== undefined) {
                        debugger;
                        this.seatsAvailable = result.seatsAvailable;
                        this.onTrialPeriod = result.onTrialPeriod;
                        this.onEndOfBillingCycle = result.onEndOfBillingCycle;

                        this.userWithoutEmail = result.user_without_email.map((item, index) => {
                            item.input_email = null;
                            item.employee_id = item.id;
                            item.payroll_calendar_id = item.PayrollCalendarID;
                            item.user_id = null;
                            item.checked = true;
                            item.showDropdown = true;
                            item.index = index;
                            item.userWithoutEmail = null;
                            item.duplicateDropdownError = false;
                            item.duplicateEmailError = false;
                            item.validEmailError = false;
                            item.inputEmptyError = false;
                            item.dropdownType = null;
                            item.backEndErrorMessage = '';
                            item.backEndError = false;
                            return item;
                        });

                        this.userToInvite = result.userToInvite.map((item, index) => {
                            item.input_email = item.email;
                            item.employee_id = item.id;
                            item.payroll_calendar_id = item.PayrollCalendarID;
                            item.checked = true;
                            item.index = index;
                            item.userToInvite = null;
                            item.showDropdown = false;
                            item.duplicateDropdownError = false;
                            item.duplicateEmailError = false;
                            item.validEmailError = false;
                            item.inputEmptyError = false;
                            item.dropdownType = null;
                            item.backEndErrorMessage = '';
                            item.backEndError = false;
                            return item;
                        });

                        this.matchUsers = result.matchUsers.map((item, index) => {
                            item.name = item.xeroEmployee.name;
                            item.input_email = null;
                            item.user_id = item.attoUser.id.toString();
                            item.employee_id = item.xeroEmployee.id;
                            item.payroll_calendar_id = item.xeroEmployee.PayrollCalendarID;
                            item.checked = true;
                            item.showDropdown = true;
                            item.index = index;
                            item.matchUsers = null;
                            item.duplicateDropdownError = false;
                            item.duplicateEmailError = false;
                            item.validEmailError = false;
                            item.inputEmptyError = false;
                            item.backEndErrorMessage = '';
                            item.backEndError = false;
                            item.dropdownType = item.attoUser.email ? 'invite' : 'user';
                            return item;
                        });

                        let users = [];
                        $.each(result.companyUsers, function (key, value) {
                            users.push({
                                value: key,
                                label: value
                            });
                        });
                        this.companyUsers = users.sort(function (a, b) {
                            return a.value - b.value;
                        });

                        this.firstStep = false;
                        this.secondStep = true;
                        this.$store.commit('hideLoading');
                    } else {
                        this.firstStep = false;
                        this.secondStep = false;
                        this.thirdStep = false;
                        this.finalStep = true;
                        this.$store.commit('hideLoading');
                    }
                }).catch(error => {
                    this.$store.commit('hideLoading');
                    if (error.response.status === 403) {
                        this.$store.commit('xeroHasError403', true);
                        this.$root.$emit('showXeroErrors');
                    }
                });
            },
            onOvertimeSelected(value) {
                this.overtime_selected = value;
            },
            onRegularSelected(value) {
                this.regular_selected = value;
            },
            submitSecondStep() {
                this.$store.commit('showLoading');
                let members = [];
                let _this = this;
                let validModalForm = true;
                let role = "3";

                _this.userWithoutEmail.forEach((member) => {
                    let entry = _this.userWithoutEmail[member.index];
                    entry.duplicateDropdownError = false;
                    entry.duplicateEmailError = false;
                    entry.validEmailError = false;
                    entry.selectOneItemError = false;
                    entry.inputEmptyError = false;
                    entry.backEndErrorMessage = '';
                    entry.backEndError = false;
                    _this.userWithoutEmail.splice(member.index, 1, entry);

                    if (member.checked === true) {
                        members.push(member);
                    }
                });

                _this.userToInvite.forEach((member) => {
                    let entry = _this.userToInvite[member.index];
                    entry.duplicateDropdownError = false;
                    entry.duplicateEmailError = false;
                    entry.validEmailError = false;
                    entry.selectOneItemError = false;
                    entry.inputEmptyError = false;
                    entry.backEndErrorMessage = '';
                    entry.backEndError = false;
                    _this.userToInvite.splice(member.index, 1, entry);
                    if (member.checked === true) {
                        members.push(member);
                    }
                });

                _this.matchUsers.forEach((member) => {
                    let entry = _this.matchUsers[member.index];
                    entry.duplicateDropdownError = false;
                    entry.duplicateEmailError = false;
                    entry.validEmailError = false;
                    entry.selectOneItemError = false;
                    entry.inputEmptyError = false;
                    entry.backEndErrorMessage = '';
                    entry.backEndError = false;
                    _this.matchUsers.splice(member.index, 1, entry);
                    if (member.checked === true) {
                        members.push(member);
                    }
                });

                let usersThatMatch = [];
                let usersToInvite = [];
                // Check Duplicated Dropdown selected
                const seenDropDown = new Set();
                let AllDuplicatedDropdown = [];
                const seenEmail = new Set();
                let AllDuplicatedEmail = [];
                const regex = /^(([^<>()[\]\\.,;:\s@\"]+(\.[^<>()[\]\\.,;:\s@\"]+)*)|(\".+\"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
                members.filter(item => {
                    if (item.user_id) {
                        const duplicateDropdown = seenDropDown.has(item.user_id);
                        seenDropDown.add(item.user_id);
                        if (duplicateDropdown) {
                            AllDuplicatedDropdown.push(item);
                        }
                    }

                    // Check Duplicated Emails in input
                    if (item.input_email) {
                        const duplicateEmail = seenEmail.has(item.input_email);
                        seenEmail.add(item.input_email);
                        if (duplicateEmail) {
                            AllDuplicatedEmail.push(item);
                        }
                    }

                    // check email validation
                    if (item.input_email !== null && item.input_email.trim() !== '' && !regex.test(item.input_email.trim())) {
                        item.validEmailError = true;
                        validModalForm = false;
                    }

                    // check if input is empty
                    if (item.showDropdown === false && item.input_email === null) {
                        item.inputEmptyError = true;
                        validModalForm = false;
                    }
                    // check if any user is selected in dropdown
                    if (item.showDropdown === true && item.user_id === null) {
                        item.selectOneItemError = true;
                        validModalForm = false;
                    }

                    // Matched user and invited user separate
                    if (item.showDropdown === true && item.user_id !== null) {
                        usersThatMatch.push({
                            user_id: item.user_id,
                            role: role,
                            employee_id: item.employee_id,
                            payroll_calendar_id: item.payroll_calendar_id,
                            type: item.dropdownType
                        });
                    }

                    if (item.showDropdown === false && item.input_email !== null) {
                        usersToInvite.push({
                            email: item.input_email,
                            role: role,
                            employee_id: item.employee_id,
                            payroll_calendar_id: item.payroll_calendar_id
                        });
                    }

                });

                AllDuplicatedDropdown.forEach((item) => {
                    if (item.userWithoutEmail !== undefined && item.userWithoutEmail == null && item.input_email === null) {
                        _this.userWithoutEmail[item.index].duplicateDropdownError = true;
                        validModalForm = false;
                    }
                    if (item.userToInvite !== undefined && item.userToInvite == null && item.input_email === null) {
                        _this.userToInvite[item.index].duplicateDropdownError = true;
                        validModalForm = false;
                    }
                    if (item.matchUsers !== undefined && item.matchUsers == null && item.input_email === null) {
                        _this.matchUsers[item.index].duplicateDropdownError = true;
                        validModalForm = false;
                    }
                });

                AllDuplicatedEmail.forEach((item) => {
                    if (item.userWithoutEmail !== undefined && item.userWithoutEmail == null) {
                        _this.userWithoutEmail[item.index].duplicateEmailError = true;
                        validModalForm = false;
                    }
                    if (item.userToInvite !== undefined && item.userToInvite == null) {
                        _this.userToInvite[item.index].duplicateEmailError = true;
                        validModalForm = false;
                    }
                    if (item.matchUsers !== undefined && item.matchUsers == null) {
                        _this.matchUsers[item.index].duplicateEmailError = true;
                        validModalForm = false;
                    }
                });


                var showStepThird = false;
                var showFinalStep = true;
                // Send data to backend
                if (validModalForm) {

                    debugger;
                    if (usersThatMatch.length > 0) {
                        CompanyService.xeroMargeUsersWithAtto(usersThatMatch).then((response) => {
                            if (usersToInvite.length === 0) {
                                _this.firstStep = false;
                                _this.secondStep = false;
                                _this.thirdStep = false;
                                _this.finalStep = true;
                                this.$store.commit('hideLoading');
                            }
                        }).catch(error => {
                            // this.disabledDeactivateButton = false;
                            // this.errorMessage = 'Error Disconnecting from QuickBooks Online';
                        });
                    }

                    if (usersToInvite.length > 0) {
                        //To Do call function for invite users

                        const data = usersToInvite.map((item, idx) => {
                            item.index = idx;
                            return item;
                        });

                        InviteService.sendInvites({
                            invites: data
                        }).then((result) => {
                            if (result.status === 201) {
                                this.purchaseSeats = result.data.purchaseSeats;
                                this.isFirstPurchaseStripeTax = result.data.isFirstPurchaseStripeTax;
                                this.proratedCostPerUser = (result.data.proratedCostPerUser).toFixed(2);
                                this.totalAmount = (this.purchaseSeats * this.proratedCostPerUser).toFixed(2);

                                this.invites = result.data.invites.map((item, idx) => {
                                    item.index = idx;
                                    item.deleting = false;
                                    item.confirm_delete = false;
                                    return item;
                                });

                                this.seats = this.invites.length > 0 ? this.invites.length : 1;

                                this.showPurchaseSeats = true;
                                showStepThird = true;
                                showFinalStep = false;

                            } else if (result.status === 210) {
                                showStepThird = false;
                                showFinalStep = false;
                                this.showResumeSubscription = true;
                            } else {
                                showStepThird = false;
                                showFinalStep = true;
                            }

                            _this.firstStep = false;
                            _this.secondStep = false;
                            _this.thirdStep = showStepThird;
                            _this.finalStep = showFinalStep;

                            this.$store.commit('hideLoading');
                        }).catch((error) => {
                            _this.firstStep = false;
                            _this.secondStep = true;
                            _this.thirdStep = false;
                            _this.finalStep = false;
                            this.$store.commit('hideLoading');
                            if (error.response.status === 422) {
                                const errors = error.response.data;
                                errors.forEach((err) => {
                                    members.forEach((member) => {
                                        if (member.showDropdown === false && member.input_email === err.email) {
                                            if (member.userWithoutEmail !== undefined && member.userWithoutEmail == null) {
                                                _this.userWithoutEmail[member.index].backEndError = true;
                                                _this.userWithoutEmail[member.index].backEndErrorMessage = err.message;
                                            }
                                            if (member.userToInvite !== undefined && member.userToInvite == null) {
                                                _this.userToInvite[member.index].backEndError = true;
                                                _this.userToInvite[member.index].backEndErrorMessage = err.message;
                                            }
                                            if (member.matchUsers !== undefined && member.matchUsers == null) {
                                                _this.matchUsers[member.index].backEndError = true;
                                                _this.matchUsers[member.index].backEndErrorMessage = err.message;
                                            }
                                        }
                                    });

                                });
                            } else if (error.response.status === 403) {
                                this.$store.commit('hideLoading');
                                this.$root.$emit('noSubscription');
                            }
                        });

                    }

                    if(usersToInvite.length === 0 && usersThatMatch.length === 0){
                        _this.firstStep = false;
                        _this.secondStep = false;
                        _this.thirdStep = false;
                        _this.finalStep = true;
                        this.$store.commit('hideLoading');
                    }

                }
                this.$store.commit('hideLoading');
            },
            close() {
                let query = Object.assign({}, this.$route.query);
                delete query.xero;
                this.$router.replace({ query });
                this.$root.$emit('hideXeroIntegration');
            },
            closePurchaseSeatsButton(){
                const _this = this;
                _this.firstStep = false;
                _this.secondStep = false;
                _this.thirdStep = false;
                _this.finalStep = true;
            },
            cancelInEmployee() {
                const _this = this;
                _this.firstStep = false;
                _this.secondStep = false;
                _this.thirdStep = false;
                _this.finalStep = true;
            },
            reactivateSubscription() {
                this.$root.$emit('showReactivateSubscription');
            },
            onUserMatchSelected(option, index) {
                this.matchUsers[index].duplicateDropdownError = false;
                this.matchUsers[index].dropdownType = this.validateEmailInDropdown(option.label);
                if (option.value == '-0') {
                    this.matchUsers[index].showDropdown = false;
                } else {
                    this.matchUsers[index].user_id = option.value;
                }
            },
            onUserSelected(option, index) {
                this.userWithoutEmail[index].duplicateDropdownError = false;
                this.userWithoutEmail[index].dropdownType = this.validateEmailInDropdown(option.label);
                if (option.value == '-0') {
                    this.userWithoutEmail[index].showDropdown = false;
                } else {
                    this.userWithoutEmail[index].user_id = option.value;
                }
            },
            validateEmailInDropdown(email) {
                let re = /^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
                return re.test(email) === false ? "user" : "invite";
            },
            onRoleSelected(option, index) {
                this.invites[index].role = option.value;
            },

            deleteInvite(item) {
                item.confirm_delete = true;
            },
            confirmDelete(item) {
                item.deleting = true;
                InviteService.deleteInvite(item.id).then((result) => {
                    const index = this.invites.indexOf(item);
                    this.invites.splice(index, 1);
                    this.seats = this.invites.length === 0 ? 1 : this.invites.length;
                }).catch((error) => {
                    item.deleting = false
                });
            },
            cancelConfirmDelete(item) {
                item.confirm_delete = false;
            },

            purchaseSeatsSubmit() {

                this.error = false;
                this.errorMessage = '';
                this.$v.$touch();
                if (this.$v.$invalid) {
                    this.errorMessage = this.label.get('subscription_please_enter_the_number_of_seats');
                    this.error = true;
                    return;
                }

                this.resetErrors();
                if (!this.validateEmails()) {
                    this.errorMessage = this.label.get('please_add_a_valid_email');
                    this.error = true;
                    return;
                }

                if (this.seats < 1 || this.seats > 999) {
                    this.errorMessage = this.label.get('subscription_please_enter_a_valid_number_of_seats');
                    this.error = true;
                    return;
                }

                this.$store.commit('showLoading');
                BillingService.purchaseSeats({
                    invites: this.invites,
                    seats: this.seats,
                    isFirstPurchaseStripeTax: this.isFirstPurchaseStripeTax
                }).then((result) => {
                  //this.payInvoice(result.data.invoice_id);
                  this.firstStep = false;
                  this.secondStep = false;
                  this.thirdStep = false;
                  this.finalStep = true;
                  this.$store.commit('hideLoading');
                }).catch((error) => {
                    this.$store.commit('hideLoading');
                    this.errorMessage = error.response.data.error.message;
                    this.error = true;
                });
            },

          payInvoice(invoiceId) {
            debugger;
            BillingService.payInvoice({
              invoice_id: invoiceId,
              retry_count: this.payInvoiceRetryCount
            }).then((result) => {
              this.firstStep = false;
              this.secondStep = false;
              this.thirdStep = false;
              this.finalStep = true;
              this.$store.commit('hideLoading');
            }).catch((error) => {
              debugger;
              console.log(error.response);
              if(error.response.status !== 423) {
                this.$store.commit("hideLoading");
                this.errorMessage = error.response.data.message;
                this.error = true;
              } else if(this.payInvoiceRetryCount < 10) {
                this.payInvoiceRetryCount++;
                setTimeout(() => {
                  this.payInvoice(invoiceId);
                }, 1000);
              }
            });
          },

            resetErrors() {
                this.invites.forEach((item) => {
                    item.error = false;
                });
            },
            validateEmails() {
                let validEmails = true;
                const regex = /^(([^<>()[\]\\.,;:\s@\"]+(\.[^<>()[\]\\.,;:\s@\"]+)*)|(\".+\"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;

                this.invites.forEach((item) => {
                    if (item.email.trim() !== '' && !regex.test(item.email.trim())) {
                        item.error = true;
                        validEmails = false;
                    }
                });

                return validEmails;
            }
        }
    }
</script>

<style lang="scss" scoped>
</style>